import { gql } from 'graphql-request';

import type { SEO } from '@/types/seo';

interface UserAgreementContent extends SEO {
  archive: {
    id: string;
    title: string;
    description: string;
    version: {
      title: string;
      downloadUrl: string;
    }[];
  }[];
}

export const createUserAgreementQuery = () => gql`
  query getUserAgreementContent {
    UserAgreement {
      archive {
        id
        title
        description
        version {
          title
          document {
            url
          }
        }
      }
      seo {
        title
        description
        image {
          url
        }
      }
    }
  }
`;

export const mapToUserAgreementContent = (data: any): UserAgreementContent => {
  return {
    archive: data.UserAgreement?.archive.map((item: any) => ({
      id: item.id,
      title: item.title,
      description: item.description,
      version: item.version.map((version: any) => ({
        title: version.title,
        downloadUrl: version.document.url,
      })),
    })),
    seo: data.UserAgreement.seo,
  };
};
